<template>
    <div>
        <div v-if="preloader">
            <div class="header_button_box">
                <div v-if="$checkUser('organisationCategory', 'view')" class="header_button_item">
                    <router-link :to="{name: 'OrganisationCategoryList'}">
                        <button class="header_button">
                            <div class="header_icons icon_list" /><span>Категории справочника</span>
                        </button>
                    </router-link>
                </div>
                <div v-if="$checkUser('organisation', 'create')" class="header_button_item">
                    <router-link :to="{name: 'OrganisationAdd'}">
                        <button class="header_button">
                            <div class="header_icons icon_add" /><span>Добавить организацию</span>
                        </button>
                    </router-link>
                </div>
            </div>
            <SearchPlagin :search-type="`Organizations`" />
            <div v-if="list && list.length" class="default_box table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col" class="text-start">
                                ID
                            </th>
                            <th scope="col" class="text-start">
                                Название
                            </th>
                            <th v-if="$checkUser('organisation', 'edit')" scope="col" class="text-end">
                                Опубликовано
                            </th>
                            <th v-if="$checkUser('organisation', 'edit') || $checkUser('organisation', 'delete')" scope="col" class="text-end">
                                Действия
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in list" :key="index">
                            <th scope="row" class="text-start">
                                <a :href="'https://okaygorod.com/' + $city.index + '/organisation/' + item.id" target="_blank" :title="'Открыть ссылку https://okaygorod.com/' + $city.index + '/organisation/' + item.id" class="link">{{ item.id }}</a>
                            </th>
                            <td class="text-start">
                                {{ $cutText(item.name, 80) }}
                            </td>
                            <td v-if="$checkUser('organisation', 'edit')" class="text-end">
                                <input id="s2" type="checkbox" class="switch" :checked="item.published === 1" :disabled="disabled_status" :true-value="1" :false-value="0" @change="api_status(item, index)">
                            </td>
                            <td v-if="$checkUser('organisation', 'edit') || $checkUser('organisation', 'delete')" class="text-end">
                                <div class="table_button_box">
                                    <router-link v-if="$checkUser('organisation', 'edit')" :to="{name: 'OrganisationEdit', params: {id: item.id}}" class="table_button_item" :title="`Редактировать организацию`">
                                        <button class="table_button table_icon_edit">
                                            <div class="table_icons icon_pen" />
                                        </button>
                                    </router-link>
                                    <div v-if="$checkUser('organisation', 'delete')" class="table_button_item" :title="`Удалить организацию`">
                                        <button class="table_button table_icon_delete" @click="del(item.id, item.name, index)">
                                            <div class="table_icons icon_trash" />
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="list && last_page && page < last_page">
                    <div v-if="button_preloader" class="news_button_block">
                        <button class="btn_primary" @click="api_next">
                            Показать ещё
                        </button>
                    </div>
                    <Preloader v-else />
                </div>
            </div>
            <div v-else class="default_box">
                В этом городе нет организаций
            </div>
        </div>
        <Preloader v-else />
    </div>
</template>
<script>
import SearchPlagin from "@/components/components/Search/SearchPlagin";
export default {
    name: "OrganisationList",
    components: {
        SearchPlagin
    },
    data() {
        return {
            disabled_status: false,
            preloader: false,
            button_preloader: true,
            page: 1,
            list: null,
            last_page: null
        }
    },
    mounted() {
        this.api();
    },
    methods: {
        api() {
            this.preloader = false;
            let url = this.$config.api_management + this.$city.index + "/Organisation";
            this.$http.get(url, {
                params: {
                    per_page: 50,
                }
            }).then((response) => {
                this.list = response.data.data;
                this.last_page = response.data.last_page;
            }).finally(() => {
                this.preloader = true;
            });
        },
        api_next() {
            this.button_preloader = false;
            let url = this.$config.api_management + this.$city.index + "/Organisation";
            this.page++;
            this.$http.get(url, {
                params: {
                    page: this.page,
                    per_page: 50,
                }
            }).then((response) => {
                this.list = this.list.concat(response.data.data);
            }).finally(() => {
                this.button_preloader = true;
            })
        },
        api_status(array, index) {
            array.published = array.published == 0 ? 1 : 0;
            let data = {
                published: array.published
            }
            this.disabled_status = true;
            let url = this.$config.api_management + this.$city.index + "/Organisation/" + array.id;
            this.$http.put(url, data).then((response) => {
                this.list[index].published = response.data.published;
                this.$toast.default("Статус организации успешно изменён");
            }).finally(() => {
                this.disabled_status = false;
            })
        },
        del(id, name, index) {
            if (confirm("Вы уверены, что хотите удалить организацию?\n\n\"" + name + "\"\n\nЭто действие нельзя отменить!")) {
                let url = this.$config.api_management + this.$city.index + "/Organisation/" + id;
                this.$http.delete(url).then((response) => {
                    if (response && response.status === 200) {
                        this.list.splice(index, 1);
                        this.$toast.default("Организация \"" + name + "\", успешно удалена");
                    } else {
                        this.$toast.error("Произошла ошибка при удалении");
                    }
                })
            }
        },
    }
}
</script>
<style scoped>
.btn_primary {
    margin-top: 50px;
    margin-bottom: 50px;
    padding: 10px 15px;
}

.header_button_box {
    justify-content: space-between;
}
</style>